/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Ufo = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M13.25 19V23H11.75V19H13.25ZM5.84882 18.1279L7.15118 18.8721L5.15118 22.3721L3.84882 21.6279L5.84882 18.1279ZM19.1512 18.1279L21.1512 21.6279L19.8488 22.3721L17.8488 18.8721L19.1512 18.1279ZM12.5 1C16.8349 1 20.3645 4.44784 20.4962 8.75082L20.5 9L23.5 13L20.5 17H4.5L1 13L4.5 9C4.5 4.58172 8.08172 1 12.5 1ZM19.751 10.5H5.179L2.992 13L5.18 15.5H19.75L21.625 13L19.751 10.5ZM12.5 12C13.0523 12 13.5 12.4477 13.5 13C13.5 13.5523 13.0523 14 12.5 14C11.9477 14 11.5 13.5523 11.5 13C11.5 12.4477 11.9477 12 12.5 12ZM7.5 12C8.05228 12 8.5 12.4477 8.5 13C8.5 13.5523 8.05228 14 7.5 14C6.94772 14 6.5 13.5523 6.5 13C6.5 12.4477 6.94772 12 7.5 12ZM17.5 12C18.0523 12 18.5 12.4477 18.5 13C18.5 13.5523 18.0523 14 17.5 14C16.9477 14 16.5 13.5523 16.5 13C16.5 12.4477 16.9477 12 17.5 12ZM12.5 2.5C8.91015 2.5 6 5.41015 6 9H19C19 5.41015 16.0899 2.5 12.5 2.5ZM14.5 4.25C16.0188 4.25 17.25 5.48122 17.25 7H15.75C15.75 6.30964 15.1904 5.75 14.5 5.75V4.25Z"
                        fill={color}
                    />
                </svg>
        );
    };
